export default class NodataIndicator {
  constructor() {
    this.chart = null;
    this.indicator = null;
  }

  createNoDataIndicator(chart) {
    const indicator = chart.tooltipContainer.createChild(am4core.Container);
    indicator.hide();
    indicator.background.fill = am4core.color('#fff');
    indicator.background.fillOpacity = 1.0;
    indicator.width = am4core.percent(100);
    indicator.height = am4core.percent(100);

    const indicatorLabel = indicator.createChild(am4core.Label);
    indicatorLabel.text = 'No data to display.';
    indicatorLabel.align = 'center';
    indicatorLabel.valign = 'middle';
    indicatorLabel.fill = am4core.color('#787878');
    indicatorLabel.fontSize = 11;
    this.indicator = indicator;
  }

  showNoDataIndicator() {
    if (this.indicator) {
      this.indicator.show();
    }
  }

  hideNoDataIndicator() {
    if (this.indicator) {
      this.indicator.hide();
    }
  }
}
